import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import {
  Container, Button, Form, Modal 
} from "react-bootstrap";
import FocusTrap from "focus-trap-react";
import http from "../../api/http-request";
import CloseIcon from "../../assets/images/close-icon.svg";
import {
  formatPhoneNumber,
  getPhoneNumberFromFormattedString,
  preventNonDigitCharacters, pageNotFound
} from "../../utils/common";

class ChangeAlternateMobileNumberPopup extends Component {
  constructor(props) {
    super(props);
    this.mobileNumberInputRef = React.createRef();
    this.verificationInputRef = React.createRef();
    this.state = {
      mobileNumber: props.alternatecontactNumber,
      verificationCode: "",
      screen: 1,
      mobileNumberUSFormatted: "",
      verificationPlaceholder:['0', '0', '0', '0', '0', '0', '0', '0'],
      userId:props.userId,
      buttonName: ""
    };
  }

  componentDidMount = () => {
     if(this.props.isLogoutLinkPresent) {
        this.setState({
          buttonName: "pages.editNumberPopup.updateAndLogout"
        });
      }
      else {
        this.setState({
          buttonName: "pages.editNumberPopup.update"
        });
      }
  }

  getAPIHeaders = () => {
    const dataStoreToken = localStorage.getItem("authToken");
    const bearer = 'Bearer ';
    return {
      Authorization: `${bearer}${dataStoreToken}`,
    };
  };

  onNext = (e) => {
    e.preventDefault();
    const { mobileNumber } = this.state;
    if (mobileNumber.length >= 1 && mobileNumber.length < 14) {
      this.setState({
        mobileNumberError: "pages.editNumberPopup.mobileNumberInvalid"
      });
      this.mobileNumberInputRef.current.focus();
    } else {
      this.setState(
        {
          mobileNumberError: "",
          mobileNumberUSFormatted: mobileNumber === "" ? "" : getPhoneNumberFromFormattedString(
            mobileNumber
          )
        },
        () => {
          this.getOtp();
        }
      );
    }
  };

  onMobileNumberChange = (e) => {
    const currentValue = e.target.value.trim();
    this.setState((prevState) => ({
      ...prevState,
      mobileNumber: formatPhoneNumber(currentValue, prevState.phoneNumber)
    }));
  };

  handleKeyPress = (e) => {
    preventNonDigitCharacters(e);
  };

  getOtp = () => {
    const { mobileNumberUSFormatted, userId } = this.state;
    const { onErrorHandler, onChangeAlternateMobileNumberHandler } = this.props;
    const usersId = userId;
    this.setState({
      errorText: "",
      mobileNumberError: ""
    });
    const payload = [
      {
        operation: "replace",
        field: "/alternatecontactNumber",
        value: mobileNumberUSFormatted
      }
    ];
    http(
      {
        url: `managed/user/${userId}`,
        method: "PATCH",
        data: payload
      },
      { ...this.getAPIHeaders() }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data._id === usersId) {
        onChangeAlternateMobileNumberHandler("success");
      } else if (
        res.status === 403 &&
        res.data.message.includes("Failed policy validation")
      ) {
        this.setState({
          mobileNumberError: "pages.editNumberPopup.alternateMobileNumberInvalid"
        });
        this.mobileNumberInputRef.current.focus();
      } else if (res.status === 200 && res.data && typeof res.data === 'string') {
        pageNotFound(res);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "MAX_RESEND_EXCEEDED") {
        onErrorHandler("error", res.data.message);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "MAX_RETRY_EXCEEDED") {
        onErrorHandler("error", res.data.message);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "OTP_EXPIRED") {
        this.setState({
          verificationCodeError: "pages.editNumberPopup.otpExpired"
        });
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "OTP_INVALID") {
        this.setState({
          verificationCodeError: "pages.editNumberPopup.otpInvalid"
        });
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "INVALID_NUMBER") {
        this.setState({
          mobileNumberError: "pages.editNumberPopup.invalidNumber"
        });
      } else if (res.status === 401 && res.data.code === 401 && res.data.message === "SEND_OTP_FAILED") {
        this.setState({
          mobileNumberError: "pages.editNumberPopup.sendOTPFailed"
        });
      } else if (res.status === 404 && res.data.code === 404 && res.data.message === "REQUESTED_RESOURCE_NOT_FOUND") {
        this.setState({
          mobileNumberError: "pages.editNumberPopup.requestedResourceNotFound"
        });
      } else if (res.status === 403 && res.data.code === 403 && res.data.message === "UNKNOWN_ERROR") {
        this.setState({
          mobileNumberError: "pages.editNumberPopup.unknownError"
        });
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "TWILIO_ERROR") {
        onErrorHandler("error", res.data.message);
      }
    });
  };

  handleVerifyChange = (vals) => {
    this.setState({
      verificationCode:vals
    })
  };

  render() {
    const { t, onClose, alternatecontactNumber, isLogoutLinkPresent } = this.props;
    const {
      mobileNumber,
      screen,
      mobileNumberError,
      numberFocus,
      buttonName
    } = this.state;

    return (
      <Modal
        show
        animation={false}
        onEscapeKeyDown={() => onClose()}
        aria-labelledby="mobile-modal"
      >
        <FocusTrap>
          <div className="popup change-mobile-number">
            <Container fluid>
              <div className="popup__wrapper">
                <Form>
                  <div className="popup__wrapper-body">
                    <div className="popup__wrapper-body-header">
                      <h6 id="mobile-modal">
                        {alternatecontactNumber
                          ? t("pages.editNumberPopup.editAlternateNumber")
                          : t("pages.editNumberPopup.addAlternatePhoneNumber")}
                      </h6>
                      <Button
                        className="popup__wrapper-body-header-close"
                        onClick={() => {
                          onClose();
                        }}
                        variant="light"
                        aria-label="Close"
                      >
                        <img src={CloseIcon} alt="" />
                      </Button>
                    </div>
                    {
                      isLogoutLinkPresent && 
                      <div className="description-content">
                       <p>{t("pages.profile.profileUpdate")}</p>
                      </div>
                      } 
                    {screen === 1 && (
                      <>
                        <p className="popup__wrapper-body-desc">
                          {t("pages.editNumberPopup.usNumber")}
                        </p>
                        <Form.Group controlId="mobileNumber">
                          <Form.Control
                            ref={this.mobileNumberInputRef}
                            className={
                              mobileNumberError ? "error-input" : undefined
                            }
                            onKeyDown={this.handleKeyPress}
                            placeholder={!numberFocus ? "(###) ###-####" : ""}
                            onFocus={() => {
                              this.setState({
                                numberFocus: true
                              });
                            }}
                            onBlur={() => {
                              this.setState({
                                numberFocus: false
                              });
                            }}
                            onChange={this.onMobileNumberChange}
                            value={mobileNumber}
                            autoFocus
                            aria-required
                            aria-invalid={!!mobileNumberError}
                            aria-describedby="mobile-number-error"
                          />
                        </Form.Group>
                        <p className="error-text" id="mobile-number-error">
                          {mobileNumberError && t(mobileNumberError)}
                        </p>
                      </>
                    )}
                  </div>
                  <div className="popup__wrapper-footer">
                    <Button
                      className="wrapper__container-card-body-submit"
                      size="lg"
                      variant="primary"
                      block
                      type="submit"
                      onClick={(e) => this.onNext(e)}
                    >
                      {t(buttonName)}
                    </Button>
                     {
                      (this.props.isLogoutLinkPresent) &&
                      <p
                        role="button"
                        tabIndex={0}
                        className="blue-link"
                        onClick={() => onClose()}
                        onKeyPress={() => onClose()}
                        aria-label={t("pages.profile.cancel")}
                      >{t("pages.profile.cancel")}</p>
                    }
                  </div>
                </Form>
              </div>
            </Container>
          </div>
        </FocusTrap>
      </Modal>
    );
  }
}

ChangeAlternateMobileNumberPopup.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeAlternateMobileNumberHandler: PropTypes.func.isRequired,
  onErrorHandler: PropTypes.func.isRequired,
  alternatecontactNumber: PropTypes.string,
  isLogoutLinkPresent: PropTypes.bool
};

ChangeAlternateMobileNumberPopup.defaultProps = {
  alternatecontactNumber: "",
  isLogoutLinkPresent: false
};
export default withTranslation()(ChangeAlternateMobileNumberPopup);
